import { useContext } from "react"
import { VideoContext } from "../context/videoContext"

export const useVideo = () => {
	const _videoContext = useContext(VideoContext)
	return _videoContext
}
